import React, { Component }  from 'react';
import {useNavigate} from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import SidebarMobile from "../Sidebar/SidebarMobile";
import {removeUserToken} from '../../service/localStorage/LocalStorageService';
import {RouteInfo} from '../../route/RouteHelper'
import {actionTypes} from '../../context/reducer'
import {useAuthDispatcher} from '../../context/AuthContext'

const Panel = ({sideBarListItems}) => {
    const navigate = useNavigate()
    const dispatch = useAuthDispatcher()

    function doUserLoginOut() {
        dispatch({
            type: actionTypes.LOGOUT,
            token: null
        })
        removeUserToken()
        navigate(RouteInfo.Login.globalUrl)
    }


    return (
        <>
            <Sidebar sideBarListItems={sideBarListItems} doLogout={doUserLoginOut}/>
            <SidebarMobile sideBarListItems={sideBarListItems} doLogout={doUserLoginOut}/>
        </>)

};
export default Panel